import { render, staticRenderFns } from "./TrackDetail.vue?vue&type=template&id=04a8c40e&scoped=true&"
import script from "./TrackDetail.vue?vue&type=script&lang=js&"
export * from "./TrackDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrackDetail.vue?vue&type=style&index=0&id=04a8c40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a8c40e",
  null
  
)

export default component.exports